// extracted by mini-css-extract-plugin
export default {"personMap":"personMap__personMap___[chunkhash-base64-5]"};